import { Box, Container, Link, Stack, Typography } from "@mui/material";
import { PayPalBadge } from "./PayPalBadge";

export function Footer() {
  return (
    <Box
      component="footer"
      sx={{ py: { xs: 4, md: 6 }, bgcolor: "background.default" }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <Box>
          <Typography variant="body2" color="text.secondary">
            © 2025 BondPay
          </Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            justifyContent="center"
            alignItems="center"
            sx={{ mt: 1, flexWrap: "wrap" }}
          >
            <Link href="/terms-of-service" underline="none" color="primary">
              Terms & Conditions
            </Link>
            <Link href="/privacy-policy" underline="none" color="primary">
              Privacy Policy
            </Link>
            <Link href="#" underline="none" color="primary">
              Rental Saving Deals
            </Link>
          </Stack>

          <PayPalBadge />
        </Box>
      </Container>
    </Box>
  );
}
